import { makeRequest, CommonRequestOptions } from '../../makeRequest';

export type RemoveBulkUsersFromTeamsOptions = CommonRequestOptions & {
   userIds: number[];
   teamIds: number[];
};

type RemoveBulkUsersFromTeamsResult = {
   id: number;
   authorid: number;
   result: string;
   no_ops: { userid: number; teamid: number }[];
   executed: { userid: number; teamid: number }[];
   created_at: number;
};

export function removeBulkUsersFromTeams({
   userIds,
   teamIds,
   ...common
}: RemoveBulkUsersFromTeamsOptions): Promise<RemoveBulkUsersFromTeamsResult> {
   return makeRequest('post', 'users/manage/bulk/remove-users-from-teams', {
      body: {
         users: userIds,
         teams: teamIds,
      },
      ...common,
   });
}
